import { render, staticRenderFns } from "./ServiceAbsencesTable.vue?vue&type=template&id=07df7ca2&"
import script from "./ServiceAbsencesTable.vue?vue&type=script&lang=js&"
export * from "./ServiceAbsencesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports